<template>
  <div class="bottom-bar">
    <div
        v-show="tarotBoxHistory.tarot_box_id !== 320"
        class="extra-question-area">
      <div class="extra-question-button"
           @click="openExtraQuestionBottomSheet"
           v-if="pageType === 'answer'"
           :style="extraQuestionButtonStyle">
        <div class="button-tag Caption4 Gray1"
             v-if="(buttonStatus === 'processing' || buttonStatus === 'paid_processing') ||
          ((buttonStatus === 'new' || buttonStatus === 'paid_new') && currentPageHasExtraQuestion)">
          {{tagText}}
        </div>
        <div class="button-new-badge" v-if="hasNewBadge"/>
      </div>
      <div class="guide" v-if="showGuide && pageType === 'answer'">
        <span class="Title4 Gray9">
          읽다가 질문이 떠오른 챕터에<br>
          <span style="color: #FFFA97">무료 심층풀이</span>받으세요
        </span>
        <img
            src="@/tarot_box/pages/box_result_v2/assets/x-button-sm.svg"
            @click="handleGuideClose"
        />
      </div>
    </div>

    <div class="shades"/>
    <div class="pagination" @click="toggleBottomSheet">
      <img v-if="hasAnyNewExtraQuestion" src="@/tarot_box/pages/box_result_v2/assets/bottom-bar/index-icon-new.svg">
      <img v-else :src="require('@/tarot_box/pages/box_result_v2/assets/bottom-bar/index-icon-default.svg')">
      {{currentIndex}} <span class="shade">&nbsp;/ {{totalIndex}}</span>
    </div>
    <div class="navigation">
      <svg @click="goPrev" width="48" height="48" viewBox="-24 -12 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.587 11.9969L16.6752 17.3343C16.8821 17.5157 16.988 17.7438 16.9928 18.0185C16.9976 18.2931 16.8917 18.5254 16.6752 18.7152C16.4586 18.9051 16.1961 19 15.8876 19C15.5791 19 15.3165 18.9051 15.1 18.7152L8.38232 12.826C8.24241 12.7033 8.14372 12.574 8.08625 12.4379C8.02875 12.3018 8 12.1548 8 11.9969C8 11.839 8.02875 11.692 8.08625 11.5559C8.14372 11.4198 8.24241 11.2905 8.38232 11.1678L15.1 5.2786C15.3069 5.09715 15.5671 5.00433 15.8804 5.00014C16.1937 4.99592 16.4586 5.08874 16.6752 5.2786C16.8917 5.46843 17 5.69858 17 5.96905C17 6.23952 16.8917 6.46967 16.6752 6.6595L10.587 11.9969Z" :fill="colorizeSVG2"/>
      </svg>
      <svg width="1" height="16" viewBox="0 0 1 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.5" y1="-2.18557e-08" x2="0.500001" y2="16" stroke="#D9D9D9"/>
      </svg>
      <svg @click="goNext" width="48" height="48" viewBox="0 -12 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.413 12.0031L7.32484 6.66569C7.11787 6.48426 7.012 6.25621 7.00721 5.98153C7.0024 5.70686 7.10828 5.47462 7.32484 5.28478C7.54138 5.09493 7.80391 5 8.11242 5C8.42094 5 8.68346 5.09493 8.9 5.28478L15.6177 11.174C15.7576 11.2967 15.8563 11.426 15.9138 11.5621C15.9713 11.6982 16 11.8452 16 12.0031C16 12.161 15.9713 12.308 15.9138 12.4441C15.8563 12.5802 15.7576 12.7095 15.6177 12.8322L8.9 18.7214C8.69305 18.9029 8.43292 18.9957 8.1196 18.9999C7.8063 19.0041 7.54138 18.9113 7.32484 18.7214C7.10828 18.5316 7 18.3014 7 18.031C7 17.7605 7.10828 17.5303 7.32484 17.3405L13.413 12.0031Z" :fill="colorizeSVG"/>
      </svg>
    </div>
  </div>
</template>

<script>
import {logEvent} from "@/tarot_box/helper/native_api";
import {
  isGuideHidden,
  hideGuideForMonth,
  hasUnreadExtraQuestion,
  initializeExtraQuestionReadStatus,
} from '@/tarot_box/utils/pageHistoryStorage';

export default {
  name: "OutputBottomBar",
  props: {
    currentIndex: Number,
    totalIndex: Number,
    isBottomSheetOpen: {
      type: Boolean,
      required: true,
    },
    tarotBoxHistory: {
      type: Object,
    },
    extraQuestionStatus: {
      type: String,
      default: 'default',
    },
    pageType: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.showGuide = !isGuideHidden('extra_question');

    // 심층풀이 읽음 상태 초기화
    if (this.tarotBoxHistory?.id) {
      initializeExtraQuestionReadStatus(this.tarotBoxHistory.id, this.tarotBoxHistory);
    }
  },
  data(){
    return {
      isWeb: this.$isWeb,
      extraQuestionImages: {
        default: 'https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/8ebe58e2-ef65-4fbf-0273-466b90746300/public',
        active: 'https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/8ebe58e2-ef65-4fbf-0273-466b90746300/public',
        finished: 'https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/8ebe58e2-ef65-4fbf-0273-466b90746300/public',
        new: 'https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/8ebe58e2-ef65-4fbf-0273-466b90746300/public',
        paid_processing: 'https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/049a2a6d-0001-4891-298a-7c9fd9358900/public',
        paid_new: 'https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/8ebe58e2-ef65-4fbf-0273-466b90746300/public',
        processing: 'https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/049a2a6d-0001-4891-298a-7c9fd9358900/public',
        paid_finished: 'https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/8ebe58e2-ef65-4fbf-0273-466b90746300/public'
      },
      showGuide: false,
    }
  },
  emits: ['closeBottomSheet', 'openBottomSheet', 'goNext', 'goPrev', 'openExtraBottomSheet', 'goNewExtraQuestion'],
  computed: {
    // 현재 페이지의 심층풀이 상태 계산
    currentPageExtraStatus() {
      if (!this.tarotBoxHistory) return null;

      // 1. 첫 번째 심층풀이 확인
      if (this.tarotBoxHistory.extra_question_page_index === this.currentIndex) {
        return this.tarotBoxHistory.extra_question_status;
      }

      // 2. extra_question_histories에서 현재 페이지 찾기
      if (this.tarotBoxHistory.extra_question_histories) {
        const currentPageHistory = this.tarotBoxHistory.extra_question_histories.find(
            h => h.page_index === this.currentIndex
        );
        return currentPageHistory?.status || null;
      }

      return null;
    },
    currentPageHasExtraQuestion() {
      if (!this.tarotBoxHistory) return false;

      // 1. 첫 번째 심층풀이 페이지 확인
      if (this.tarotBoxHistory.extra_question_page_index === this.currentIndex) {
        return true;
      }

      // 2. extra_question_histories에서 현재 페이지 확인
      if (this.tarotBoxHistory.extra_question_histories) {
        return this.tarotBoxHistory.extra_question_histories.some(
            h => h.page_index === this.currentIndex
        );
      }

      return false;
    },

    // 현재 페이지에 new 배지 표시 여부 (로컬스토리지 기반)
    hasNewBadge() {
      // processing 상태일 때는 기존 로직 유지
      if (this.extraQuestionStatus === 'processing' ||
          this.extraQuestionStatus === 'paid_processing') {
        return false;
      }

      // 로컬스토리지에서 읽지 않은 심층풀이 확인
      if (this.tarotBoxHistory?.id && this.currentIndex) {
        return hasUnreadExtraQuestion(this.tarotBoxHistory.id, this.currentIndex);
      }

      return false;
    },

    // 전체적으로 new 상태가 있는지 확인 (pagination 아이콘용)
    hasAnyNewExtraQuestion() {
      if (!this.tarotBoxHistory) return false;

      // processing 상태일 때는 false
      if (this.extraQuestionStatus === 'processing' ||
          this.extraQuestionStatus === 'paid_processing') {
        return false;
      }

      // 각 페이지별로 읽지 않은 심층풀이가 있는지 확인
      const historyId = this.tarotBoxHistory.id;

      // 첫 번째 심층풀이 페이지 확인
      if (this.tarotBoxHistory.extra_question_page_index &&
          hasUnreadExtraQuestion(historyId, this.tarotBoxHistory.extra_question_page_index)) {
        return true;
      }

      // 히스토리의 각 페이지 확인
      if (this.tarotBoxHistory.extra_question_histories) {
        return this.tarotBoxHistory.extra_question_histories.some(
            h => hasUnreadExtraQuestion(historyId, h.page_index)
        );
      }

      return false;
    },

    // 버튼 상태 (스타일과 태그 표시용)
    buttonStatus() {
      // processing 상태는 전체 상태 우선
      if (this.extraQuestionStatus === 'processing' ||
          this.extraQuestionStatus === 'paid_processing') {
        return this.extraQuestionStatus;
      }

      // 로컬스토리지 기반으로 new 상태 확인
      if (this.hasNewBadge) {
        // paid 여부는 전체 상태에서 확인
        if (this.extraQuestionStatus?.includes('paid')) {
          return 'paid_new';
        }
        return 'new';
      }

      // 현재 페이지에 심층풀이가 있으면 finished
      if (this.currentPageExtraStatus) {
        if (this.extraQuestionStatus?.includes('paid')) {
          return 'paid_finished';
        }
        return 'finished';
      }

      // 그 외는 전체 상태 사용
      return this.extraQuestionStatus || 'default';
    },

    extraQuestionButtonStyle() {
      const backgroundImage = this.extraQuestionImages[this.buttonStatus];
      return {
        backgroundImage: `url(${backgroundImage})`
      };
    },

    tagText(){
      const status = this.buttonStatus;
      if (status === 'new' || status === 'paid_new') {
        return '풀이완료';
      } else if (status === 'processing' || status === 'paid_processing') {
        return '풀이중';
      } else {
        return '';
      }
    },

    colorizeSVG() {
      if (this.isBottomSheetOpen || this.currentIndex === this.totalIndex) {
        return '#CCCCCC';
      } else {
        return '#333333';
      }
    },

    colorizeSVG2() {
      if (this.isBottomSheetOpen) {
        return '#CCCCCC';
      } else {
        return '#333333';
      }
    }
  },
  methods: {
    toggleBottomSheet() {
      logEvent('result_UI_index_click', {});
      if (this.isBottomSheetOpen) {
        this.$emit('closeBottomSheet');
      } else {
        this.bottomSheetType = 'index';
        this.$emit('openBottomSheet');
      }
    },

    goNext() {
      if (!this.isBottomSheetOpen && this.currentIndex !== this.totalIndex) {
        logEvent('result_UI_next_click', {});
        this.$emit('goNext');
      }
    },

    goPrev() {
      if (!this.isBottomSheetOpen) {
        logEvent('result_UI_prev_click', {});
        this.$emit('goPrev');
      }
    },

    handleGuideClose() {
      // 로그 이벤트
      logEvent('extra_question_guide_close', {});

      // 1개월간 숨기기
      hideGuideForMonth('extra_question');

      // UI에서 즉시 숨기기
      this.showGuide = false;
    },

    openExtraQuestionBottomSheet() {
      const urlParams = new URLSearchParams(window.location.search);
      const isShare = urlParams.get('is_share') === 'true';

      if(isShare && this.$isWeb) {
        logEvent('result_appdown_popup', {
          page_index: this.currentIndex,
          has_extra_question: this.currentPageExtraStatus !== null
        });
        this.$emit('openExtraBottomSheet');
        return;
      }
      // 로컬스토리지 기반으로 new 상태 확인
      const hasNew = this.hasNewBadge;

      // 현재 페이지에 새로운 심층풀이가 있으면 바로 스크롤
      if (hasNew) {
        logEvent('result_UI_extra_question_new_click', {
          page_index: this.currentIndex,
          status: this.buttonStatus
        });

        this.$emit('goNewExtraQuestion');
      } else {
        // 심층풀이 바텀시트 열기
        logEvent('result_UI_extra_question_click', {
          page_index: this.currentIndex,
          has_extra_question: this.currentPageExtraStatus !== null
        });
        this.$emit('openExtraBottomSheet');
      }
    }
  },
  watch: {
    // tarotBoxHistory가 변경되면 읽음 상태 재초기화
    tarotBoxHistory: {
      handler(newVal) {
        if (newVal?.id) {
          initializeExtraQuestionReadStatus(newVal.id, newVal);
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.bottom-bar{
  width: 100vw;
  padding: 8px 24px calc(8px + var(--safe-area-bottom)) 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;

  background: white;
  border-top: 1px solid var(--Grayscale-Gray10, #ECECEC);
}

.extra-question-area{
  position: absolute;
  top : -70px;
  right: 12px;
  display: flex;
  flex-direction: row-reverse;
  justify-items: flex-end;
  gap: 10px;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.30));
}

.extra-question-button{
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #00081C;
  border: 2px solid #D5F7FF;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.button-tag{
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 8px;
  width: max-content;
  border-radius: 20px;
  background: #D5F7FF
}

.button-new-badge{
  position: absolute;
  top: 0;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--Alert-Color);
}

.guide{
  display: flex;
  padding: 12px 12px 12px 20px;
  justify-content: space-between;
  align-items: center;
  border-radius: 50px;
  gap: 14px;
  text-align: left;
  background: linear-gradient(90deg, #01081D 19.15%, #001287 100%);
}

.guide img{
  cursor: pointer;
}

.shades{
  position: absolute;
  top: -15px;
  left: 0;
  width: 100vw;
  height: 15px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 100%);
  z-index: 100;
}

.pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--Grayscale-Gray3, #333);
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'dlig' on;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.navigation{
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 14px;
  transform: translateX(24px);
}

.shade{
  color: var(--Grayscale-Gray8, #CCC);
}
</style>